<app-maintenance-accordion *ngIf="!isEmpty(activities) else noItems" [items]="activities"
                           [grouperOnly]="true"
                           (selectionChanged)="selectionChanged($event)">
</app-maintenance-accordion>
<ng-template #noItems>
    <h5 class="no-items">{{ 'admin.tickets.create-modal.info.noRecurrences' | translate }}</h5>
</ng-template>
